export default "__VITE_ASSET__UvrF8kLi__ 224w, __VITE_ASSET__BfkNe9z9__ 448w";